import angular from 'angular';

function Directive() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<div ng-transclude></div>',
    link: (scope, element) => {

      const $el = angular.element(element);

      scope.$watch('calendarConfig', function(newValue) {
        if (newValue) {
          scope.calendar = $el.fullCalendar(newValue);
        }
      });
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/fullcalendar/index.js